<div
    *tuiRepeatTimes="let x of columnsNumber"
    class="t-column"
>
    <div
        *tuiRepeatTimes="let y of rowsNumber"
        class="t-cell"
        [class.t-cell_hovered]="tableSelectHovered(y, x)"
        (mouseenter)="updateCurrentSize(y + 1, x + 1, $event)"
        (click)="select()"
    ></div>
</div>
<div class="t-description">{{ tableSize.cols }}&#215;{{ tableSize.rows }}</div>
